import { render, staticRenderFns } from "./MetadataHeader.vue?vue&type=template&id=429f2158&scoped=true&"
import script from "./MetadataHeader.vue?vue&type=script&lang=js&"
export * from "./MetadataHeader.vue?vue&type=script&lang=js&"
import style0 from "./MetadataHeader.vue?vue&type=style&index=0&id=429f2158&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429f2158",
  null
  
)

export default component.exports